import moment from 'moment';
import update from 'immutability-helper';

import {
  FETCH_VT_TEMPLATES_START,
  FETCH_VT_TEMPLATES_FULFILLED,
  FETCH_VT_TEMPLATES_REJECTED,
  SET_SELECTED_START_DATE,
  SET_START_DATE_DATA,
  SET_SELECTED_END_DATE,
  SET_END_DATE_DATA,
  SET_EXERCISES,
  SET_BUCKET_SIZE,
  SET_OVERVIEW_RANGE_MAX,
  SET_OVERVIEW_RANGE_MIN,
  SET_ASSIGNED_COMPLETED_RANGE_MAX,
  SET_ASSIGNED_COMPLETED_RANGE_MIN,
  SET_ACTIVE_VT_DASH,
  CLEAR_ACTIVE_VT_DASH,
  FETCH_EXERCISES_START,
  FETCH_EXERCISES_FULFILLED,
  FETCH_EXERCISES_REJECTED,
  FETCH_GROUPS_START,
  FETCH_GROUPS_FULFILLED,
  FETCH_GROUPS_REJECTED,
  FETCH_VT_DASH_DATA_START,
  FETCH_VT_DASH_DATA_FULFILLED,
  FETCH_VT_DASH_DATA_REJECTED,
  SET_NEXT_LOCATION,
  SET_GROUP,
  SET_GROUPS,
  FETCH_ATHLETES_FROM_GROUP_START,
  FETCH_ATHLETES_FROM_GROUP_FULFILLED,
  FETCH_ATHLETES_FROM_GROUP_REJECTED,
  SET_SELECTED_ATHLETE,
  SET_EXERCISE_FILTERS,
  CREATE_VT_TEMPLATE_START,
  CREATE_VT_TEMPLATE_FULFILLED,
  CREATE_VT_TEMPLATE_REJECTED,
  SET_ABOUT_VT_DASH_MODAL,
  FETCH_PUBLIC_VT_DASH_DATA_START,
  FETCH_PUBLIC_VT_DASH_DATA_FULFILLED,
  FETCH_PUBLIC_VT_DASH_DATA_REJECTED,
  SET_DUPLICATE_VT_DASH_MODAL,
  DUPLICATE_VT_TEMPLATE_START,
  DUPLICATE_VT_TEMPLATE_FULFILLED,
  DUPLICATE_VT_TEMPLATE_REJECTED,
  SET_EDIT_VT_DASH_MODAL,
  EDIT_VT_TEMPLATE_START,
  EDIT_VT_TEMPLATE_FULFILLED,
  EDIT_VT_TEMPLATE_REJECTED,
  SET_DELETE_VT_DASH_MODAL,
  DELETE_VT_TEMPLATE_START,
  DELETE_VT_TEMPLATE_FULFILLED,
  DELETE_VT_TEMPLATE_REJECTED,
  SET_SHARE_VT_DASH_MODAL,
  FETCH_SHARE_VT_DASH_LINK_START,
  FETCH_SHARE_VT_DASH_LINK_FULFILLED,
  FETCH_SHARE_VT_DASH_LINK_REJECTED,
  CLEAR_SHARE_VT_DASH_LINK,
  CLEAR_VT_DASH_DATA,
  CLEAR_VT_DASH_MODALS,
} from './actionTypes';

const initialState = {
  aboutTemplate: null,
  activeTemplate: null,
  assignedCompletedRangeMax: 100,
  assignedCompletedRangeMin: 50,
  athleteList: [],
  availableExercises: [],
  bucketSize: 10,
  createTemplateError: null,
  dashBGColor: null,
  dashCreator: null,
  dashLogo: null,
  dashDescription: null,
  dashTitle: null,
  deleteTemplate: {},
  deleteError: null,
  duplicateTemplate: {},
  duplicateError: null,
  editTemplate: {},
  editError: null,
  endDateData: moment().format('YYYY-MM-DD'),
  exercises: [],
  exerciseFilters: [],
  group: null,
  groups: [],
  nextLocation: null,
  overviewRangeMax: 100,
  overviewRangeMin: 0,
  selectedAthlete: null,
  selectedEndDate: moment(),
  selectedStartDate: moment().subtract(13, 'days'),
  shareTemplate: {},
  shareDashLink: null,
  shareDashLinkError: null,
  startDateData: moment().subtract(13, 'days').format('YYYY-MM-DD'),
  templates: [],
  templateError: null,
  vtDashData: [],
  vtDashError: null,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_VT_TEMPLATES_START:
      return {
        ...state,
        templateError: null,
      };
    case FETCH_VT_TEMPLATES_FULFILLED:
      return {
        ...state,
        templates: action.payload,
        templateError: null,
      };
    case FETCH_VT_TEMPLATES_REJECTED:
      return {
        ...state,
        templates: [],
        templateError: action.payload,
      };
    case SET_ACTIVE_VT_DASH:
      return {
        ...state,
        activeTemplate: action.payload,
      };
    case CLEAR_ACTIVE_VT_DASH:
      return {
        ...state,
        activeTemplate: null,
        endDateData: moment().format('YYYY-MM-DD'),
        selectedEndDate: moment(),
        selectedStartDate: moment().subtract(13, 'days'),
        startDateData: moment().subtract(13, 'days').format('YYYY-MM-DD'),
      };
    case SET_BUCKET_SIZE: {
      return {
        ...state,
        bucketSize: action.payload,
      };
    }
    case SET_OVERVIEW_RANGE_MAX: {
      return {
        ...state,
        overviewRangeMax: action.payload,
      };
    }
    case SET_OVERVIEW_RANGE_MIN: {
      return {
        ...state,
        overviewRangeMin: action.payload,
      };
    }
    case SET_ASSIGNED_COMPLETED_RANGE_MAX: {
      return {
        ...state,
        assignedCompletedRangeMax: action.payload,
      };
    }
    case SET_ASSIGNED_COMPLETED_RANGE_MIN: {
      return {
        ...state,
        assignedCompletedRangeMin: action.payload,
      };
    }
    case FETCH_EXERCISES_START:
      return {
        ...state,
        availableExercises: [],
      };
    case FETCH_EXERCISES_FULFILLED:
      return {
        ...state,
        availableExercises: action.payload,
      };
    case FETCH_EXERCISES_REJECTED:
      return {
        ...state,
        availableExercises:
          action.payload.response && action.payload.response.data
            ? action.payload.response.data
            : action.payload,
      };
    case FETCH_GROUPS_START:
      return {
        ...state,
        groups: [],
      };
    case FETCH_GROUPS_FULFILLED:
      return {
        ...state,
        groups: action.payload,
      };
    case FETCH_GROUPS_REJECTED:
      return {
        ...state,
        groups: [],
      };
    case FETCH_VT_DASH_DATA_START:
      return {
        ...state,
      };
    case FETCH_VT_DASH_DATA_FULFILLED:
      return {
        ...state,
        vtDashData: action.payload.vtDashData,
        vtDashError: null,
      };
    case FETCH_VT_DASH_DATA_REJECTED:
      return {
        ...state,
        vtDashData: [],
        vtDashError: action.payload,
      };
    case SET_SELECTED_START_DATE: {
      return {
        ...state,
        selectedStartDate: action.payload,
      };
    }
    case SET_START_DATE_DATA: {
      return {
        ...state,
        startDateData: action.payload,
      };
    }
    case SET_SELECTED_END_DATE: {
      return {
        ...state,
        selectedEndDate: action.payload,
      };
    }
    case SET_END_DATE_DATA: {
      return {
        ...state,
        endDateData: action.payload,
      };
    }
    case SET_EXERCISES: {
      const sortedExercises = [...action.payload].sort((a, b) => a.name.localeCompare(b.name));
      return {
        ...state,
        exercises: action.payload,
        exerciseFilters: sortedExercises.length > 0 ? [sortedExercises[0]] : [],
      };
    }
    case SET_NEXT_LOCATION: {
      return {
        ...state,
        nextLocation: action.payload,
      };
    }
    case SET_GROUP: {
      return {
        ...state,
        group: action.payload,
      };
    }
    case SET_GROUPS: {
      return {
        ...state,
        groups: action.payload,
      };
    }
    case FETCH_ATHLETES_FROM_GROUP_START: {
      return {
        ...state,
        athleteList: [],
      };
    }
    case SET_SELECTED_ATHLETE: {
      return {
        ...state,
        selectedAthlete: action.payload.athlete,
      };
    }
    case FETCH_ATHLETES_FROM_GROUP_FULFILLED: {
      return {
        ...state,
        athleteList: action.payload,
      };
    }
    case FETCH_ATHLETES_FROM_GROUP_REJECTED: {
      return {
        ...state,
        athleteList: [],
      };
    }
    case SET_EXERCISE_FILTERS: {
      return {
        ...state,
        exerciseFilters: action.payload,
      };
    }
    case CREATE_VT_TEMPLATE_START: {
      return {
        ...state,
        createTemplateError: null,
      };
    }
    case CREATE_VT_TEMPLATE_FULFILLED: {
      return {
        ...state,
        activeTemplate: action.payload,
        templates: [...state.templates, action.payload],
        createTemplateError: null,
      };
    }
    case CREATE_VT_TEMPLATE_REJECTED: {
      return {
        ...state,
        createTemplateError: action.payload,
      };
    }
    case SET_ABOUT_VT_DASH_MODAL: {
      return {
        ...state,
        aboutTemplate: action.payload.template,
      };
    }
    case FETCH_PUBLIC_VT_DASH_DATA_START: {
      return {
        ...state,
        scDashError: null,
      };
    }
    case FETCH_PUBLIC_VT_DASH_DATA_FULFILLED: {
      const incomingMax = action.payload.rangeMax === 100
        ? 110 : action.payload.rangeMax + action.payload.bucketSize;
      const incomingMin = action.payload.rangeMin;
      const range = incomingMax - incomingMin;
      const maxBucketRange = action.payload.bucketSize * 5;
      const assignedMin = range <= maxBucketRange
        ? incomingMin : Math.max(0, incomingMax - maxBucketRange);

      return {
        ...state,
        assignedCompletedRangeMax: incomingMax,
        assignedCompletedRangeMin: assignedMin,
        athleteList: action.payload.users.map((user) => ({
          id: user.id,
          first: user.name.split(' ')[0],
          last: user.name.split(' ').slice(1).join(' '),
        })),
        bucketSize: action.payload.bucketSize,
        dashTitle: action.payload.dashboardTitle,
        dashDescription: action.payload.dashboardDescription,
        dashCreator: action.payload.creator,
        dashLogo: action.payload.account.logo,
        dashBGColor: action.payload.account.primaryColor,
        endDateCal: moment(action.payload.endDate),
        endDateData: action.payload.endDate,
        exerciseFilters: action.payload.exercises.length
          ? [action.payload.exercises.sort((a, b) => a.name.localeCompare(b.name))[0]]
          : [],
        exercises: action.payload.exercises,
        group: action.payload.group,
        overviewRangeMin: action.payload.rangeMin,
        overviewRangeMax: incomingMax,
        startDateCal: moment(action.payload.startDate),
        startDateData: action.payload.startDate,
        vtDashData: action.payload.dashboardData,
        vtDashError: null,
      };
    }
    case FETCH_PUBLIC_VT_DASH_DATA_REJECTED: {
      return {
        ...state,
        athleteList: [],
        vtDashData: [],
        vtDashError: action.payload,
      };
    }
    case SET_DUPLICATE_VT_DASH_MODAL: {
      return {
        ...state,
        duplicateTemplate: action.payload.template,
      };
    }
    case DUPLICATE_VT_TEMPLATE_START: {
      return {
        ...state,
        duplicateError: null,
      };
    }
    case DUPLICATE_VT_TEMPLATE_FULFILLED: {
      return update(state, {
        templates: {
          $push: [action.payload],
        },
      });
    }
    case DUPLICATE_VT_TEMPLATE_REJECTED: {
      return {
        ...state,
        duplicateError: action.payload,
      };
    }
    case SET_EDIT_VT_DASH_MODAL: {
      return {
        ...state,
        editTemplate: action.payload.template,
      };
    }
    case EDIT_VT_TEMPLATE_START: {
      return {
        ...state,
        editError: null,
      };
    }
    case EDIT_VT_TEMPLATE_FULFILLED: {
      return update(state, {
        templates: {
          [action.payload.index]: {
            $set: action.payload.data,
          },
        },
        editTemplate: {
          $set: {},
        },
        editError: {
          $set: null,
        },
      });
    }
    case EDIT_VT_TEMPLATE_REJECTED: {
      return {
        ...state,
        editError: action.payload,
      };
    }
    case SET_DELETE_VT_DASH_MODAL: {
      return {
        ...state,
        deleteTemplate: action.payload.template,
      };
    }
    case DELETE_VT_TEMPLATE_START: {
      return {
        ...state,
        deleteError: null,
      };
    }
    case DELETE_VT_TEMPLATE_FULFILLED: {
      return update(state, {
        templates: {
          $splice: [[action.payload.index, 1]],
        },
        deleteTemplate: {
          $set: {},
        },
      });
    }
    case DELETE_VT_TEMPLATE_REJECTED: {
      return {
        ...state,
        deleteError: action.payload,
      };
    }
    case SET_SHARE_VT_DASH_MODAL: {
      return {
        ...state,
        shareTemplate: action.payload.template,
      };
    }
    case FETCH_SHARE_VT_DASH_LINK_START: {
      return {
        ...state,
        shareDashLink: null,
        shareDashLinkError: null,
      };
    }
    case FETCH_SHARE_VT_DASH_LINK_FULFILLED: {
      return {
        ...state,
        shareDashLink: action.payload,
        shareDashLinkError: null,
      };
    }
    case FETCH_SHARE_VT_DASH_LINK_REJECTED: {
      return {
        ...state,
        shareDashLink: null,
        shareDashLinkError: action.payload,
      };
    }
    case CLEAR_SHARE_VT_DASH_LINK: {
      return {
        ...state,
        shareDashLink: null,
        shareDashLinkError: null,
      };
    }
    case CLEAR_VT_DASH_DATA: {
      return {
        ...state,
        activeTemplate: null,
        group: null,
        endDateData: moment().format('YYYY-MM-DD'),
        selectedAthlete: null,
        selectedEndDate: moment(),
        selectedStartDate: moment().subtract(13, 'days'),
        startDateData: moment().subtract(13, 'days').format('YYYY-MM-DD'),
        vtDashData: [],
      };
    }
    case CLEAR_VT_DASH_MODALS: {
      return {
        ...state,
        aboutTemplate: null,
        deleteTemplate: {},
        editTemplate: {},
      };
    }
    default: {
      return {
        ...state,
      };
    }
  }
}
